const trackingUtils = require('od-modules/utils/tracking.utils');
const trackFrontEventsUtils = require('od-modules/track_events/track.frontevents.utils');

function getSortedItemsDescending() {
    return Odigeo._.range(this.options.minRating, this.options.maxRating + 1).sort((a, b) => b - a);
}

function getReview(item) {
    const [rate, value] = _(this.model.get('items')).pick(item).pairs().first();

    return {rate, value};
}

function retrieveSelectedReviews() {
    return Odigeo._.reduce(this.$el.find(this.slctrs.inputsReview),
        (memo, value) => memo.concat($(value).data('reviewNumber')), []);
}

function hasSelectedReview(review) {
    return !hasDisabledReview(review) && this.model.hasSelectedItem(review.rate);
}

function hasDisabledReview(review) {
    return review.value === 0;
}

function getChecked(review) {
    return hasSelectedReview.call(this, review) ? 'checked="checked"' : '';
}

function getDisabled(review) {
    return hasDisabledReview.call(this, review) ? 'disabled="disabled"' : '';
}

function sendToFather(msg) {
    this.$el.trigger('filterHasChanged.accommodationfilter', msg);
}

module.exports = Odigeo.View.extend({
    ignoreModelUpdate: false,

    events: {
        'change .accommodationReviewFilter:not(:disabled)': 'userReviewSelection',
    },

    slctrs: {
        inputsReview: '.accommodationReviewFilter:checked',
    },

    init() {
        this.options = Odigeo.parseOptions(this.widget.options);
        this.sortItems = getSortedItemsDescending.call(this);
        this.sortBullets = Odigeo._.clone(this.sortItems).reverse();
        this.$el.on('updateFilterStatus.accommodationfilter', Odigeo._.bind(this.model.updateFilterStatus, this.model));
        this.$el.on('resetFilterStatus.accommodationfilter', Odigeo._.bind(this.cleanReviewFilter, this));
    },

    userReviewSelection(evt) {
        const $selectedReviews = $(evt.currentTarget);
        const isSelected = $selectedReviews.is(':checked');
        const checkedItem = $selectedReviews.data('reviewNumber');

        sendToFather.call(this, {
            reviewFilterModel: [{
                selectedItems: retrieveSelectedReviews.call(this),
            }],
        });

        if (isSelected) {
            trackingUtils.trackEvent('results_filters_hotels', `tripadvisor_score_${checkedItem}`);
            trackFrontEventsUtils.trackClickEvent(evt);
        }
    },

    cleanReviewFilter() {
        sendToFather.call(this, {
            reviewFilterModel: [{selectedItems: []}],
        });
    },

    beforeInsertTemplate() {
        return {
            sortItems: this.sortItems,
            sortBullets: this.sortBullets,
            getReview: Odigeo._.bind(getReview, this),
            checked: Odigeo._.bind(getChecked, this),
            disabled: Odigeo._.bind(getDisabled, this),
        };
    },

    render() {
        if (this.model.hasItems()) {
            this.setTemplate(this.$el, this.options.mainTemplate);
        }
    },
});
